import { format } from "date-fns";
import { parseIsoDate } from "web_myplann/Portfolio/Forms/dateParsers";
import type { ManualValueFormOutput } from "web_myplann/Portfolio/PortfolioShared/ManualValue/manualValueFormTypes";
import { sortManualValuesNewestFirst } from "web_myplann/Portfolio/PortfolioShared/ManualValue/sortManualValuesNewestFirst";
import type { ToolPreviousValue } from "web_myplann/Portfolio/PortfolioShared/ManualValue/toolPreviousValueSchema";
import { DateFormat } from "web_myplann/Shared/Utils/dateFormats";

type ToolValueUpdate = ManualValueFormOutput & {
	previousValues: ToolPreviousValue[];
};

type ToolCurrentValue = {
	value: number | null;
	invested: number | null;
	valueDate: Date | null;
	valueId: number | null;
};

export const applyToolValueUpdate = (
	current: ToolCurrentValue,
	update: ToolValueUpdate,
) => {
	const currentDate = current.valueDate
		? format(current.valueDate, DateFormat.Iso)
		: null;
	const isSameDay = currentDate === update.valueDate;
	const movedToPrevious: ToolPreviousValue[] =
		!isSameDay &&
		update.value !== null &&
		current.value !== null &&
		currentDate !== null
			? [
					{
						id: current.valueId,
						value: current.value,
						invested: current.invested,
						date: currentDate,
					},
				]
			: [];

	return {
		value: update.value,
		invested: update.invested,
		valueDate: parseIsoDate(update.valueDate),
		valueId: isSameDay && update.value !== null ? current.valueId : null,
		previousValues: sortManualValuesNewestFirst([
			...movedToPrevious,
			...update.previousValues.filter(
				({ date }) => update.value === null || date !== update.valueDate,
			),
		]),
	};
};
